<template>
  <b-card>
    <b-row>
      <b-col md="12">
        <label for="sync-params-logical-number">Origem</label>
        <v-select
          id="sync-params-logical-number"
          placeholder="Selecione um numero logico"
          v-model="form.originCode"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          label="name"
          :reduce="val => val.code"
          :options="origins"
          :tabindex="0"
        >
          <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
        </v-select>
      </b-col>
      <b-col md="12">
        <label>Filtro</label>  
        <b-form-textarea rows="4" v-model="form.filter" autocomplete="off" />
      </b-col>
      
      <b-col md="12">
        <b-button
          class="btn-sm btn-nav-link btn-nav-link-white"
          size="sm"
          variant="flat-primary"
          @click="loadData"
          >Pesquisar</b-button
        >
      </b-col>
    </b-row>
    <custom-g-table
      v-if="displayTable"
      :displayLoading="tableLoading"
      :fields="fields"
      :items="data"
      :hasEditButton="true"
      :hasDeleteButton="false"
      :totalRows="totalRows"
      :limit="limit"
    />
  </b-card>
</template>

<script>
import { BCard, BButton, BRow, BCol, BFormTextarea } from "bootstrap-vue";
import CustomGTable from "@/views/custom/table/CustomGTable.vue";
import clientService from "@/providers/clientService";
import AppConstants from "@/appConstants";
import vSelect from "vue-select";
import dropdownService from "@/providers/dropdownService";
import formatFieldHelper from '@/helpers/format-field-helper';

export default {
  props: {
    currentFilter: String
  },
  components: {
    CustomGTable,
    BCard,
    BButton,
    BRow,
    BCol,
    BFormTextarea,
    vSelect,
  },
  data() {
    return {
      filterRights: "",
      displayTable: false,
      sortField: {},
      data: [],
      totalRows: 0,
      limit: AppConstants.PAGINATOR_DEFAULT_LIMIT,
      page: 1,
      filterFields: [],
      filter: {},
      tableLoading: true,
      fields: [
        { field: "filter", label: "Filtro", sortable: false },
        { field: "origin", label: "Origem", sortable: false },
        { field: "commodity", label: "Commodity", sortable: false },
        { field: "package", label: "Pacote", sortable: false },
        { field: "content", label: "Conteúdo", sortable: false },
        { field: "characteristic", label: "Característica", sortable: false },
        { field: "periodicity", label: "Periodicidade", sortable: false },
        { field: "country", label: "País", sortable: false },
        {
          field: "exclusive",
          label: "Exclusivo",
          sortable: false,
          type: "boolean",
        },
      ],
      origins: [],
      logicalNumber: [],
      form: {
        filter: "",
        originCode: 0,
      },
    };
  },
  mounted() {
    if (this.currentFilter) {
      this.form.filter = this.currentFilter;
    }
    this.loadDataFilter();
  },
  computed: {},
  methods: {
    reportData() {
      const params = this.searchParams;
      params.append("download", true);
      clientService
        .report(params)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", "clientes.xlsx");
          link.setAttribute("id", "link-download");

          document.body.appendChild(link);
          link.click();

          document.getElementById("link-download").remove();
        })
        .catch((err) => console.log(err));
    },
    loadDataFilter() {
      const params = new URLSearchParams();
      // params.append('code', [AppConstants.ORIGINS.CMA_MARKETS, AppConstants.ORIGINS.SAFRAS_PLATFORM].join());
      params.append('sync_client_siga', true);
      Promise.all([dropdownService.getAllOrigin(params)])
        .then((resp) => {
          this.origins = resp[0].map((item) => {
            item.name = `${item.name} - ${item.code}`;
            return item;
          });
        })
        .catch((err) => console.log(err));
    },
    loadData() {
      this.tableLoading = true;
      const body = {
          filter: this.form.filter,
          originCode: this.form.originCode
      }
      if (body.filter.includes('[')) {
          body.filter = body.filter.replace('[', '');
      }
      if (body.filter.includes(']')) {
          body.filter = body.filter.replace(']', '');
      }
      if (body.filter.includes('"')) {
          body.filter = formatFieldHelper.replaceAll(body.filter, '"', '');
      }
      body.filter = body.filter.split(',');
      console.log(body);
      clientService
        .getFilterRights(this.searchParams, body)
        .then((res) => {
          this.displayTable = true;
          this.tableLoading = false;
          // console.log(res);
          this.data = res;
        })
        .catch((err) => {
          this.displayTable = true;
          console.log(err);
        });
    },
  },
};
</script>

<style>
</style>